import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V11H22V2ZM7.00391 5.5L7.00391 7.50391H5V5.5H7.00391ZM11.0039 5.5L11.0039 7.50391H9V5.5H11.0039Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 13H2V22H22V13ZM7.00391 16.5V18.5039H5V16.5H7.00391ZM11.0039 18.5039H9V16.5H11.0039V18.5039Z"}}]};

const SystemApplicationFilled = Vue.extend<IconProps>({
  name: 'SystemApplicationFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'system-application-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default SystemApplicationFilled;
